import { Fragment } from "react";

import { Button } from "@mui/material";

import { GridItem, GridRow } from "commons/ui/Grid";

import ApartmentRatesForm from "components/form/ApartmentRatesForm";

import { SaveContextProvider } from "context/save";

import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Tariffe aggiornate con successo",
        errorMsg: "Errore nell'aggiornamento delle tariffe",
    });

    return (
        <GridRow justifyContent={"right"}>
            <GridItem className={"button-under-paper"}>
                <Button variant={"contained"} onClick={onButtonClick}>
                    Salva
                </Button>
            </GridItem>
        </GridRow>
    );
}

function Tariffe() {
    return (
        <Fragment>
            <GridRow className={"title-top-paper"}>
                <GridItem>
                    <h1>Tariffe Appartamenti</h1>
                </GridItem>
            </GridRow>

            <SaveContextProvider>
                <ApartmentRatesForm />

                <ButtonSave />
            </SaveContextProvider>
        </Fragment>
    );
}

export default Tariffe;
